import {
    useRef
    //, useState
} from 'react'

export const useFormData = (initialState) => {
   // const [formData, setFormData] = useState(initialState);
    const data = useRef(initialState);

    const setInputValue = (name, value) => {
        // setFormData(prevState => {
        //     return { ...prevState, [name]: value};
        // });
        data.current[name] = value;
        //console.log(data.current)
    }

    const setInputValues = (newState , cb) => {
        // setFormData(prevState => {
        //     return { ...prevState, ...newState}
        // });
        // data.current = {...data.current, ...newState};
        for (const [key, value] of Object.entries(newState)) {
            data.current[key] = value;
        }

        if (cb) {
            cb(data.current);
        }

        //console.log(data.current)
    }

    const inputChangeHandler = (name) => {
        return (e) => {
           // console.log(e)
            setInputValue(name, e.value);
        }
    }

    return {
        formData : data.current,
        setInputValue,
        setInputValues,
        inputChangeHandler
    }
};
